import { getCurrentInstance } from "vue";

export function useMatomo() {
  const instance = getCurrentInstance();
  if (!instance) {
    throw new Error("useMatomo must be called within a component setup function");
  }
  return instance.appContext.config.globalProperties.$matomo;
}
